import React from 'react';
import Messenger from './components/Messenger';
import script from './scene';
import OptionProvider from './contexts/OptionContext';
import OrchestratorProvider from './contexts/OrchestratorContext';
import DataProvider from './contexts/DataContext';
// import userAvatarDefault from './assets/img/mariana.png';
// import botAvatarDefault from './assets/img/mauricio@2x.png';

// const grillBurger = {
// header: {
//   icon: 'https://static-images.ifood.com.br/image/upload/t_thumbnail/logosgde/00c6abc9-afe1-4e5e-aad3-27c0c705f6c2/201903062145_i_bfj.png',
//   iconSize: '80px',
//   background: '#000',
//   foreground: '#FFF',
// },
//   dialog: {
//     userAvatar: userAvatarDefault,
//     botAvatar: botAvatarDefault,
//     foreground: '#00F',
//   },
//   input: {
//     foreground: '#fff',
//     background: {
//       colorA: '#4c4c4c',
//       colorB: '#666666',
//     },
//     button: {
//       background: '#fff',
//       foreground: '#000',
//     },
//   },
// };

const smv = {
  header: {
    icon: 'https://clint-hub.s3-sa-east-1.amazonaws.com/logo_clint_symbol.svg',
    iconSize: '25px',
    background: '#6c19de',
    // foreground: '#FFF',
  },
  // input: {
  //   foreground: '#fff',
  //   background: {
  //     colorA: '#000',
  //     colorB: '#444',
  //   },
  //   button: {
  //     background: '#fff',
  //     foreground: '#000',
  //   },
  // },
};

const novo = {
  header: {
    icon: 'https://clint-hub.s3-sa-east-1.amazonaws.com/logo_clint_symbol.svg',
    iconSize: '25px',
    background: '#6c19de',
  },
};
const eduzz = {
  header: {
    icon: 'https://dbcx89f08bina.cloudfront.net/img/logo_clint_symbol.svg',
    icon2: 'https://dbcx89f08bina.cloudfront.net/img/eduzz-logo-white.svg',
    iconSize: '25px',
    background: '#6c19de',
  },
};

const seven = {
  header: {
    icon: 'https://dbcx89f08bina.cloudfront.net/img/logo_clint_symbol.svg',
    icon2: 'https://dbcx89f08bina.cloudfront.net/img/eduzz-logo-white.svg',
    iconSize: '25px',
    background: '#6c19de',
  },
};

const getScenePath = (scenePath) => {
  switch (scenePath) {
    case 'partners':
      return smv;
    case 'eduzz':
      return eduzz;
    case 'seven':
      return seven;
    default:
      return novo;
  }
};

const Bot = () => {
  const scenePath = window.location.pathname.replace('/', '');
  document.title = scenePath === 'eduzz' ? 'Assistente Virtual - Clint + Eduzz' : 'Assistente Virtual - Clint';
  // document.querySelector('meta[name="description"]').setAttribute('content', data.metaDescription);
  return (
    <OptionProvider option={getScenePath(scenePath)}>
      <DataProvider>
        <OrchestratorProvider script={scenePath ? script[scenePath] : script.default}>
          <Messenger />
        </OrchestratorProvider>
      </DataProvider>
    </OptionProvider>
  );
};

export default Bot;
